import { Role } from "../../types/role";

const Tan: Role = {
  primary: [
    "Ballannahme",
    "Dribbling",
    "Passen",
    "Technik",
    "Entscheidungen",
    "Flair",
    "Nervenstaerke",
    "OhneBall",
    "Uebersicht",
    "Antritt",
  ],
  secondary: ["Abschluss", "Antizipation", "Balance", "Beweglichkeit"],
  physis: "angriff",
};

export const T = {
  Tan,
};
